import { IRestModel, RestApi } from "@nkr/utils/rest-api";

export interface IDashCannedResponse extends IRestModel {
    id              : number,
    name            : string,
    emailSubject    : string,
    emailContent    : string,
    type            : number,
}

export const DashCannedResponseApi = new RestApi<IDashCannedResponse, IDashCannedResponse>(`${__API__}/center/{centerId}/dash/canned-response`)
    .makeHooks()
;

export const useCannedResponseSenderApi = ( registrationId : string | number ) => {
    registrationId = registrationId || '{registrationId}'; //having {registrationId} in URL will prevent 404 calls
    const instance = new RestApi<IDashCannedResponse, IDashCannedResponse>(`${__API__}/center/{centerId}/dash/${registrationId}/email`);
    return instance.makeHooks();
}